import { render, staticRenderFns } from "./chequesRejections.vue?vue&type=template&id=707ceedc&scoped=true&"
import script from "./chequesRejections.vue?vue&type=script&lang=js&"
export * from "./chequesRejections.vue?vue&type=script&lang=js&"
import style0 from "./chequesRejections.vue?vue&type=style&index=0&id=707ceedc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707ceedc",
  null
  
)

export default component.exports